module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Arte RO.037c5960.png";